import React from "react";

import TournamentStandings from "../Tournaments/TournamentStandings";
import { Col, Container, Nav, Row } from "react-bootstrap";
import { store } from "../..";
import {
    tournamentManagementActions,
    selectSelectedTournament,
} from "../../features/tourneymgmt/tournamentManagementSlice";
import { IMasterTournament, ITournament } from "../../types/api";
import { useAppSelector } from "../../hooks/reduxHooks";
import { isChildTournament } from "../../lib/utils";

export const loader = async ({ params }: any) => {
    store.dispatch(
        tournamentManagementActions.setselectedTournamentId(
            parseInt(params.tournamentId),
        ),
    );

    let tournaments = store.getState().tournamentmanagement.tournaments;
    let masterTournaments =
        store.getState().tournamentmanagement.masterTournaments;

    const tournamentsPromise =
        tournaments.length &&
        tournaments.find(t => t.id === params.tournamentId)?.standings
            ? Promise.resolve()
            : store.dispatch(tournamentManagementActions.getTournaments());

    const masterTournamentsPromise = masterTournaments.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getMasterTournaments());

    await Promise.all([tournamentsPromise, masterTournamentsPromise]);

    const tournamentId =
        store.getState().tournamentmanagement.selectedTournament;

    const tournament = selectSelectedTournament(store.getState());
    tournaments = store.getState().tournamentmanagement.tournaments;
    masterTournaments = store.getState().tournamentmanagement.masterTournaments;

    const isChild = isChildTournament(tournament);
    const masterTournament = isChild
        ? masterTournaments.find(
              mt =>
                  mt.id ===
                  tournaments.find(t => t.id === tournamentId)?.parent,
          )
        : tournament;

    const header = isChild
        ? `${masterTournament?.name} - ${tournament.ageLevel} Standings`
        : `${tournament?.name} - All Standings`;

    return {
        header,
    };
};

const TournamentManagementTournamentStandings = (): React.JSX.Element => {
    const tournament = useAppSelector(selectSelectedTournament) as
        | ITournament
        | IMasterTournament;

    const isChild = isChildTournament(tournament);
    const { tournaments } = useAppSelector(state => state.tournamentmanagement);

    return (
        <div data-testid="tournamentContent">
            <Container className="tournament py-2 py-lg-0" fluid="xs">
                <Row>
                    <Col>
                        {isChild ? (
                            tournament.standings ? (
                                <TournamentStandings
                                    data={tournament}
                                    expanded
                                    bordered
                                    showLinks={false}
                                />
                            ) : (
                                <Row>
                                    <Col>
                                        <h2>No reported standings</h2>
                                    </Col>
                                </Row>
                            )
                        ) : (
                            <>
                                {tournaments
                                    .filter(t => t.parent === tournament.id)
                                    .every(t => !t.standings) ? (
                                    <Row>
                                        <Col>
                                            <h2>No reported standings</h2>
                                        </Col>
                                    </Row>
                                ) : (
                                    <Row>
                                        <Col>
                                            <Nav>
                                                {tournaments
                                                    .filter(
                                                        t =>
                                                            t.parent ===
                                                            tournament.id,
                                                    )
                                                    .filter(t => t.standings)
                                                    .map(t => (
                                                        <Nav.Item
                                                            key={`navLink-${t.id}`}
                                                        >
                                                            <h2>
                                                                <a
                                                                    href={`#${t.ageLevel}`}
                                                                    className="nav-link"
                                                                >
                                                                    {t.ageLevel}
                                                                </a>
                                                            </h2>
                                                        </Nav.Item>
                                                    ))}
                                            </Nav>
                                            {tournaments
                                                .filter(
                                                    t =>
                                                        t.parent ===
                                                        tournament.id,
                                                )
                                                .map(t => (
                                                    <div
                                                        id={t.ageLevel}
                                                        key={`tournament-${t.id}`}
                                                    >
                                                        <TournamentStandings
                                                            data={t}
                                                            expanded
                                                            bordered
                                                            showLinks={false}
                                                            isMulti={true}
                                                            showHeader={true}
                                                        />
                                                    </div>
                                                ))}
                                        </Col>
                                    </Row>
                                )}
                            </>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default TournamentManagementTournamentStandings;
